module.exports = __webpack_public_path__ + "assets/img/7_948.2fbe79dc.jpg";